export const countryKeys = {
	countries: () => ["countries"],
};
